(() => {
  const setup = () => {
    const menu = document.querySelector('[data-sgfh-mobile-menu]');
    if (menu && !menu.dataset.bound) {
      menu.dataset.bound = 'true';
      menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) menu.open = false;
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', (event) => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      });
    }
    const submission = document.querySelector('.sgfh-submission-details');
    if (submission) {
      if (submission.querySelector('.sgfh-form-success,.sgfh-form-errors')) submission.open = true;
      const anchor = document.querySelector('a[href^="#sgfh-directory-submit-"]');
      if (anchor && !anchor.dataset.bound) {
        anchor.dataset.bound = 'true';
        anchor.addEventListener('click', () => { submission.open = true; });
      }
    }
    document.querySelectorAll('.sgfh-header .sgfh-submenu').forEach((item) => {
      if (item.dataset.bound) return;
      item.dataset.bound = 'true';
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        item.closest('nav').querySelectorAll('.sgfh-submenu').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.sgfh-desktop-nav .sgfh-submenu[open]').forEach((item) => { item.open = false; item.querySelector('summary').focus(); });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.sgfh-desktop-nav .sgfh-submenu[open]').forEach((item) => { if (!item.contains(event.target)) item.open = false; });
  });
})();
